// extracted by mini-css-extract-plugin
module.exports = {"container":"centeredbutton_container__9HEGp"};